import type { PusherService } from "@phurshell/psiapp-frontend-core/infra";
import { PusherServiceAdapter } from "@/app/adapters/PusherServiceAdapter";

export const pusherService: PusherService = new PusherServiceAdapter(
  process.env.VUE_APP_PUSHER_KEY as string,
  process.env.VUE_APP_PUSHER_CLUSTER as string,
);
